export function formatPhoneNumberWithSpaces(phoneNumber: string) {
  const regex = /^([0-9]{2})([0-9]{2})([0-9]{2})([0-9]{2})$/;

  return phoneNumber.replace(regex, '$1 $2 $3 $4');
}
